import routerOptions0 from "/vercel/path0/node_modules/.pnpm/nuxt@3.7.3_@types+node@18.17.19_eslint@8.50.0_less@4.2.0_stylelint@14.16.1_typescript@5.2.2_vue-tsc@1.8.13/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {}
export default {
...configRouterOptions,
...routerOptions0,
}